import React, { useState, useEffect, useContext } from "react";
import styles from "../ExportPdf/ExportPdfModal.module.css";
import CloseModalIcon from "../../../assets/closeModalIcon.svg";
import { getStoresFromDatabase } from "../../../hooks/Store";
import { exportExpiredProducts } from "../../../hooks/ExpiredProduct";
import { StoresContext } from '../../../context/StoresContext';
import { ExpiredProductContext } from '../../../context/ExpiredProductContext';
import { FilterExpiredProductContext } from '../../../context/FilterExpiredProductContext';
import { TransformDateToBrazilianFormat } from "../../../utils/TransformDateToBrazilianFormat";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function Modal({ closeModal }) {
  const [selectedStoreState, setSelectedStoreState] = useState(null);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [stores, setStores] = useState([]);
  const [progress, setProgress] = useState(0);
  const [isProcessing, setIsProcessing] = useState(false);
  const {selectedStore} = useContext(StoresContext);
  const {expiredFilteredProducts} = useContext(ExpiredProductContext);
  const {isFilter} = useContext(FilterExpiredProductContext);

  useEffect(() => {
    if(selectedStore === null || selectedStore === undefined) {
      const fetchStores = async () => {
        const storeData = await getStoresFromDatabase();
        if (storeData) {
          setStores(storeData.data.stores);
        }
      };
      fetchStores();

    }else {
      setSelectedStoreState(selectedStore)
    }
  }, []);
  const handleStoreSelection = (store) => {
    setSelectedStoreState(store);
  };

  const exportExpiredProductsData = async () => {
    if (!selectedStoreState) {
      toast.error("Selecione uma loja.");
      return;
    }
    setIsProcessing(true);
    setProgress(0);
    try {
      const expiredProductData = await exportExpiredProducts([selectedStoreState.id])
      if( expiredProductData ) {
        const { expiredProducts } = expiredProductData.data;
        if (!expiredProducts || expiredProducts.length === 0) {
          toast.error("Nenhum produto encontrado para esta loja.");
          setIsProcessing(false);
          return;
        }

        await generateExpiredProductPDF(selectedStoreState.name, expiredProducts);
        setProgress(100);
        toast.success("Exportação concluída com sucesso!");
      }
    } catch (error) {
      console.error("Erro ao exportar planilha:", error);

    } finally {
      setIsProcessing(false);
    } 
  };

  const exportExpiredFilteredProducts = async () => {
    if (!expiredFilteredProducts) {
      toast.error("Sem filtros.");
      return;
    }
    setIsProcessing(true);
    setProgress(0);
    try {
      await generateExpiredProductPDF(selectedStoreState.name, expiredFilteredProducts);
      setProgress(100);
      toast.success("Exportação concluída com sucesso!");
     
    } catch (error) {
      console.error("Erro ao exportar planilha:", error);
    }finally {
      setIsProcessing(false);
    }
  }

  const onExport = () => {
    if(isFilter) {
      exportExpiredFilteredProducts()
    }else {
      exportExpiredProductsData()
    }
  }

  const generateExpiredProductPDF = async (storeName, expiredProducts) => {
    try {
      const doc = new jsPDF();
      doc.setFontSize(10);
      doc.text(`Produtos Monitorados - ${storeName}`, 14, 20);
      const formattedProducts = expiredProducts.map((expiredProduct) => [
        expiredProduct.product.barcode,
        expiredProduct.product.name,
        expiredProduct.product.manufacturer,
        expiredProduct.product.group,
        expiredProduct.quantity,
        expiredProduct.lot,
        TransformDateToBrazilianFormat(expiredProduct.expirationDate),
        expiredProduct.daysToExpire,
        expiredProduct.quantitySold ?? "-",
        expiredProduct.quantityLost,
        expiredProduct.balance,
        expiredProduct.location,
        expiredProduct.user.name,
      ]);
  
      const headers = [
        [
          "Código de Barras",
          "Descrição",
          "Fabricante",
          "Grupo",
          "Quantidade",
          "Lote",
          "Data Validade",
          "Dias a Vencer",
          "Vendido",
          "Perdido",
          "Saldo",
          "Localização",
          "Colaborador",
        ],
      ];
      autoTable(doc, {
        head: headers,
        body: formattedProducts,
        startY: 30,
        styles: {
          fontSize: 6,
          cellWidth: 'auto',
          overflow: 'linebreak',
          lineWidth: 0.1,
          lineColor: [150, 150, 150],
        },
        headStyles: {
          fillColor: [22, 160, 133],
          fontSize: 6,
          halign: 'left',
          lineWidth: 0.1,
          lineColor: [150, 150, 150],
        },
        columnStyles: {
          0: { cellWidth: 19 },
          1: { cellWidth: 15 },
          2: { cellWidth: 15 },
          3: { cellWidth: 15 },
          4: { cellWidth: 15 },
          5: { cellWidth: 15 },
          6: { cellWidth: 18 },
        },
        margin: { left: 0, right: 0 }
      });
      doc.save(`Produtos_${storeName}.pdf`);
      console.log(`PDF gerado com sucesso para a loja: ${storeName}`);
    } catch (error) {
      console.error("Erro ao gerar o PDF:", error);
      toast.error("Erro ao gerar o PDF. Tente novamente.");
    }
  };
  return (
    <div className={styles.modalBackground}>
      <ToastContainer/>
      <div className={styles.modalContainer}>
        <div className={styles.content}>
          <div className={styles.imageContainer}>
            <img src={CloseModalIcon} onClick={closeModal} alt="Fechar Modal" />
          </div>
          <h2>Exportar PDF de produtos monitorados</h2>
          <div className={styles.inputContainer}>
            <label>Selecione a loja:</label>
            <div
              className={styles.selectWrapper}
              onClick={() => setDropdownOpen(!dropdownOpen)}
            >
              <div className={styles.dropdownHeader}>
                <span id={styles.selectStores}>
                  {selectedStoreState ? selectedStoreState.name : "Selecionar loja"}
                </span>
                <span className={styles.dropdownArrow}>▼</span>
              </div>
              {dropdownOpen && (
                <div className={styles.dropdownList}>
                  {stores.map((store) => (
                    <div className={styles.radioItem} key={store.id}>
                      <input
                        type="radio"
                        id={store.id}
                        name="storeSelection"
                        checked={selectedStoreState?.id === store.id}
                        onChange={() => handleStoreSelection(store)}
                      />
                      <label htmlFor={store.id}>{store.name}</label>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
          {isProcessing && (
          <div className={styles.spinnerContainer}>
            <div className={styles.spinner}></div>
          </div>
        )}
        </div>
        <div className={styles.buttonContent}>
        <button
            className={styles.buttonConfirm}
            onClick={ onExport }>
            Exportar Produtos
          </button>
          <button onClick={ closeModal } className={styles.buttonCancel} disabled={isProcessing}>
            Cancelar
          </button>
        </div>
      </div>
    </div>
  );
}

export default Modal;
